import { Component, OnInit, Input } from '@angular/core';
import { DatabaseService } from '../../../services/database.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OpanaiService } from '../../../services/openai.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { v4 as uuidv4 } from "uuid";

// import { EnvironmentService } from '../../../services/enviroment.service';
// import { environment } from '../../../services/global-environment';;

import { environment } from '../../../services/global-environment';

interface CompanyOption {
  id: string;
  name: string;
}


// 法条接口
interface LawArticle {
  article_id: string;
  article_type: string;
  article_no: string;
  article_content: string;
  compliance_result?: ComplianceResult;
}

// 合规性结果接口
interface ComplianceResult {
  result: {
    compliance: string | null;
    non_compliance: string | null;
    irrelevant: string | null;
  };
  current_status: string;
  last_updated_date: string;
  attachment?: any;
  comments?: string;
  assign_to?: string;
  mark?: any;
  updated_by?: string;
}

// 法律详情接口
interface LawDetail {
  law_id: string;
  law_source: string;
  law_url: string;
  law_key: string;
  law_name: string;
  law_publish_date: string;
  law_modified_date: string;
  law_version: string;
  law_category: string;
  law_hierarchy: string;
  law_articles: LawArticle[];
  summary:summary;
}

// 合规性数据接口
interface summary {
  summary_text: string;
  updatedBy: string;
  updatedDate: string;
}

// 合规性数据接口
interface ComplianceData {
  companyid: string;
  topic: string;
  type: string;
  laws: LawDetail;
  id: string;
  departments?: string[];
  notes?: string;
}

// 篩選條件介面
interface FilterCriteria {
  dateRange: {
    startDate: string;
    endDate: string;
  };
  departments?: string[];
  status?: string[];
  keyword?: string;
}

// 排序條件介面
interface SortCriteria {
  field: string;
  direction: 'asc' | 'desc';
}


@Component({
  selector: 'app-compliance-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './compliance-list.component.html',
  styleUrls: ['./compliance-list.component.scss'],
})
export class ComplianceListComponent implements OnInit {
  public isClearingAll: boolean = false;
  private apiUrl = environment.apiUrl;

  // 控制刪除時的全版面 loading
  public isDeleting: boolean = false;

  @Input() companyId: string = ''; // Default company ID

  selectedStatusFilter: 'all' | 'compliance' | 'non_compliance' | 'irrelevant' | 'pending' = 'all';

  // Data containers
  complianceData: any[] = []; // Main data container
  filteredComplianceData: any[] = []; // Filtered data for display

  lawsWithCount: any[] = [];

  // Filter options
  uniqueTopics: string[] = [];
  uniqueTypes: { type: string; count: number }[] = [];
  selectedTopic: string = '';
  selected_law_id: string = '';

  // Popup handling
  isPopupVisible = false;
  selectedCompliance: any = null;
  selectedDetails: any[] = [];

  // 法规详情
  selectedLawDetails: ComplianceData | null = null;

  // 法条
  selectedLawArticles: LawArticle[] = [];

  // 部门相关
  selectedDepartments: string[] = [];
  deptInput: string = '';
  filteredDepartments: string[] = [];
  showDeptDropdown: boolean = false;
  activeIndex: number = -1;

  // 备注
  lawNotes: string = '';

  // 合规统计属性
  totalArticles: number = 0;
  compliantCount: number = 0;
  nonCompliantCount: number = 0;
  irrelevantCount: number = 0;
  pendingCount: number = 0;
  completionRate: number = 0;
  taskCreationDate: string = '';
  taskAssignee: string = '';

  // 添加一個屬性來存儲所有法規的法條
  allArticles: LawArticle[] = [];

  // 追蹤寶箱是否已收集
  treasureCollected: boolean[] = [false, false, false, false];

  // 添加屬性控制統計區域的顯示狀態
  isStatsVisible: boolean = true;

  // 批次設定狀態相關屬性和方法
  batchStatus: string = ''; // 用於批次選擇下拉選單

  // 添加批次目前狀態屬性
  batchCurrentStatus: string = '';

  // 添加這些屬性到元件類中
  showTreasureModal: boolean = false;
  treasureModalTitle: string = '';
  treasureModalContent: string = '';
  treasureModalIcon: string = 'fa-gift';
  treasureContentLoading: boolean = false;
  modalBgColor: string = '#ffecc5';
  modalBorderColor: string = '#f5820d';

  // Add these properties to your component class
  public distinctInfo: any[] = [];
  public selectedCompanyId: string = '';
  public selectedTopicFilter: string = '';
  public selectedTitleFilter: string = '';

  dataLoaded: boolean = false;

  // 添加專用的 loading 狀態變數用於 loadData 方法
  isLoading: boolean = false;

  // 添加一個屬性來存儲原始狀態
  private originalStatusMap: Map<string, string> = new Map();

  // 新增屬性
  public availableTasks: any[] = [];
  public tasksLoaded: boolean = false;

  //用來儲存任務的所有完整資料
  alldata : any[] = [];
  //用來儲存篩選後的資料
  filteredData: any[] = [];

  // Add this property to your component class
  public isTaskLoading: boolean = false;
  public selectedTask: any = null; // Add this property to store the selected task

  // 用來儲存使用者的部門權限
  userDepartments:string[] = [];
  // 用來儲存使用者的角色ID
  userroleid: string[] = [];

  // 法規 Summary 相關屬性
  selectedLawSummary: string = '';
  isSummaryLoading: boolean = false;
  summaryLastUpdated: string = '';
  summaryUpdatedBy: string = '';


  // 篩選和排序相關屬性
  filterCriteria: FilterCriteria = {
    dateRange: {
      startDate: '',
      endDate: ''
    },
    departments: [],
    status: [],
    keyword: ''
  };

  // 保證 filterCriteria.dateRange 永遠不為 undefined
  private ensureDateRange() {
    if (!this.filterCriteria.dateRange) {
      this.filterCriteria.dateRange = { startDate: '', endDate: '' };
    }
    if (typeof this.filterCriteria.dateRange.startDate !== 'string') {
      this.filterCriteria.dateRange.startDate = '';
    }
    if (typeof this.filterCriteria.dateRange.endDate !== 'string') {
      this.filterCriteria.dateRange.endDate = '';
    }
  }

  sortCriteria: SortCriteria = {
    field: '',
    direction: 'desc'
  };

  // 篩選展開/收起狀態
  isFilterExpanded: boolean = false;

  // 可選的部門清單
  availableDepartments: string[] = [];

  // 可選的狀態清單
  availableStatuses: string[] = ['已完成', '進行中', '已逾期', '未開始', '待審核', '審核通過', '審核不通過'];

  // 下拉選單選擇的值
  selectedDepartmentFilter: string = '';
  selectedFilterStatus: string = '';

  // 原始任務數據（用於篩選）
  originalTasks: any[] = [];

  // 審核相關屬性
  showReviewModal: boolean = false;
  reviewModalTitle: string = '';
  reviewComment: string = '';
  reviewType: 'approve' | 'reject' = 'approve';

  // 改善項目相關屬性
  includeImprovementItems: boolean = false;
  nonComplianceCount: number = 0;


  constructor(
    private databaseService: DatabaseService,
    private openaiService: OpanaiService,
    private http: HttpClient,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {

    this.companyId = environment.companyid
    this.selectedCompanyId = this.companyId;

    this.load_user_permission();

    // Add this to your existing ngOnInit
    this.loadDistinctInfo();
  }


  async load_user_permission(){
    try {
      // 從 URL 參數中取得 assistantNo (id 參數)
      const assistantNo = this.route.snapshot.queryParams['id'];

      if (!assistantNo) {
        console.warn('無法從 URL 中取得 assistantNo (id 參數)');
        return;
      }

      console.log('從 URL 取得的 assistantNo:', assistantNo);

      this.userDepartments = await this.authService.load_user_permission(assistantNo);

      console.log('取得使用者部門權限:', this.userDepartments);

      // 您可以在這裡處理取得的部門權限，例如：
      // - 儲存到元件屬性中
      // - 根據權限篩選資料
      // - 更新UI顯示

    } catch (error) {
      console.error('載入使用者權限時發生錯誤:', error);
    }
  }


  load_compliance_detail(): void {
  if (!this.selected_law_id) {
    this.selectedLawDetails = null;
    this.selectedLawArticles = [];
    this.resetSummaryData();
    return;
  }

  // 直接從 this.filteredData 取出對應的法規資料
  const found = this.filteredData.find(item => item.laws && item.laws.law_id === this.selected_law_id);

  if (found) {
    this.selectedLawDetails = found;
    this.selectedLawArticles = (found.laws.law_articles || []).map((article: LawArticle) => {
      if (!article.compliance_result) {
        article.compliance_result = {
          result: {
            compliance: null,
            non_compliance: null,
            irrelevant: null,
          },
          current_status: '',
          last_updated_date: '',
        };
      }
      if (!article.compliance_result.result) {
        article.compliance_result.result = {
          compliance: null,
          non_compliance: null,
          irrelevant: null,
        };
      }
      return article;
    });
    this.allArticles = [...this.allArticles, ...this.selectedLawArticles];
    this.selectedDepartments = found.departments || [];
    this.lawNotes = found.notes || '';

// 載入法規 Summary
    this.loadLawSummary(this.selectedLawDetails?.laws?.summary?.summary_text || '');

  } else {
    this.selectedLawDetails = null;
    this.selectedLawArticles = [];
    this.selectedDepartments = [];
    this.lawNotes = '';
    this.resetSummaryData();
  }
}

loadLawSummary(summary: string): void {
this.selectedLawSummary = summary || '';
}

  // 添加方法來載入所有法規的合規統計數據
 loadAllLawsStatistics(): void {

  // 重置統計數據
  this.resetComplianceStats();
  this.allArticles = [];

  // 如果沒有法規，直接返回
  if (!this.alldata || !this.alldata.length) {
    return;
  }

  // 遍歷 alldata，收集所有法條
  this.alldata.forEach((item) => {
    const articles = item.laws?.law_articles || [];
    articles.forEach((article: LawArticle) => {
      // 確保每個法條都有合規結果對象
      if (!article.compliance_result) {
        article.compliance_result = {
          result: {
            compliance: null,
            non_compliance: null,
            irrelevant: null,
          },
          current_status: '',
          last_updated_date: '',
        };
      }
      if (!article.compliance_result.result) {
        article.compliance_result.result = {
          compliance: null,
          non_compliance: null,
          irrelevant: null,
        };
      }
      this.allArticles.push(article);
    });
  });

  // 計算統計數據
  this.calculateAllLawsStats();
}

  // 計算所有法規的總體統計數據
 calculateAllLawsStats(): void {

  // 重置計數器
  this.totalArticles = 0;
  this.compliantCount = 0;
  this.nonCompliantCount = 0;
  this.irrelevantCount = 0;
  this.pendingCount = 0;

  // 遍歷 alldata，統計所有法條（排除章節標題）
  this.alldata.forEach(item => {
    const articles = item.laws?.law_articles || [];
    articles.forEach((article: LawArticle) => {
      // 排除章節標題（article_type === 'C'）
      if (article.article_type === 'C') {
        return;
      }

      this.totalArticles++;
      if (article.compliance_result && article.compliance_result.result) {
        if (article.compliance_result.result.compliance === 'V') {
          this.compliantCount++;
        } else if (article.compliance_result.result.non_compliance === 'V') {
          this.nonCompliantCount++;
        } else if (article.compliance_result.result.irrelevant === 'V') {
          this.irrelevantCount++;
        } else {
          this.pendingCount++;
        }
      } else {
        this.pendingCount++;
      }
    });
  });

  // 計算完成率
  if (this.totalArticles > 0) {
    const assessed = this.totalArticles - this.pendingCount;
    const rawRate = (assessed / this.totalArticles) * 100;

    // 只要有未判別項目，完成率最高只能顯示99%
    if (this.pendingCount > 0) {
      this.completionRate = Math.min(99, Math.round(rawRate));
    } else {
      // 只有當沒有未判別項目時，才允許顯示100%
      this.completionRate = Math.round(rawRate);
    }
  } else {
    this.completionRate = 0;
  }

  console.log('整體合規統計數據:', {
    總條數: this.totalArticles,
    符合: this.compliantCount,
    不符合: this.nonCompliantCount,
    不適用: this.irrelevantCount,
    尚未判別: this.pendingCount,
    完成率: this.completionRate,
  });
}
  // Select a type and update filtering
  selectType(lawId: string): void {
    this.selected_law_id = lawId;
    this.load_compliance_detail();

    // 不要在這裡計算統計數據，只載入選定法規的詳細資訊
  }

  // 處理並合併法規和結果數據
  private processComplianceData(regulations: any[], results: any[]): void {
    // 創建law_id到法規數據的映射，以便快速查找
    const regulationMap = new Map();
    regulations.forEach((regulation) => {
      if (regulation.laws) {
        regulationMap.set(regulation.laws.law_id, regulation);
      }
    });

    // 合併數據並格式化用於顯示
    this.filteredComplianceData = results.map((result) => {
      const regulation = regulationMap.get(result.law_id);

      return {
        ...result,
        law_name: regulation?.laws?.law_name || result.law_id,
        law_publish_date: regulation?.laws?.law_publish_date,
        law_modified_date: regulation?.laws?.law_modified_date,
        law_category: regulation?.laws?.law_category,
        law_hierarchy: regulation?.laws?.law_hierarchy,
        // 添加法規數據中需要的其他字段

        // 結果中未提供時的默認狀態
        status: result.status || 'pending',
        check_date: result.check_date || '未檢查',
        department: result.department || '未指派',
        checker: result.checker || '未指派',
      };
    });

    console.log('處理後的合規數據:', this.filteredComplianceData);
  }

  // 格式化文章内容
  formatArticleContent(content: string): string {
    return content ? content.replace(/\n/g, '<br>') : '';
  }



  // 处理键盘导航
  handleKeyDown(event: KeyboardEvent): void {
    if (!this.showDeptDropdown) return;

    if (event.key === 'ArrowDown') {
      this.activeIndex = Math.min(
        this.activeIndex + 1,
        this.filteredDepartments.length - 1
      );
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      this.activeIndex = Math.max(this.activeIndex - 1, 0);
      event.preventDefault();
    } else if (event.key === 'Enter' && this.activeIndex >= 0) {
      this.selectDepartment(this.filteredDepartments[this.activeIndex]);
      event.preventDefault();
    }
  }

  // 添加部门
  addDepartment(): void {
    if (!this.deptInput || this.deptInput.trim() === '') return;

    const dept = this.deptInput.trim();
    if (!this.selectedDepartments.includes(dept)) {
      this.selectedDepartments.push(dept);
      this.saveDepartments();
    }

    this.deptInput = '';
    this.showDeptDropdown = false;
  }

  // 移除部门
  removeDepartment(index: number): void {
    this.selectedDepartments.splice(index, 1);
    this.saveDepartments();
  }

  // 选择部门
  selectDepartment(dept: string): void {
    if (!this.selectedDepartments.includes(dept)) {
      this.selectedDepartments.push(dept);
      this.saveDepartments();
    }

    this.deptInput = '';
    this.showDeptDropdown = false;
  }

  // 保存部门信息到服务器
  saveDepartments(): void {
    if (!this.selectedLawDetails) return;

    // 调用API保存部门信息
    // this.databaseService.saveLawDepartments(
    //   this.companyId,
    //   this.selectedLawDetails.id,
    //   this.selectedDepartments
    // ).subscribe({
    //   next: (response) => {
    //     console.log('Departments saved successfully');
    //   },
    //   error: (err) => {
    //     console.error('Failed to save departments:', err);
    //   }
    // });
  }

  // 更新合規性結果
  updateComplianceResult(article: any, field: string, value: string): void {
    // 初始化結果對象（如果不存在）
    if (!article.compliance_result) {
      article.compliance_result = {
        result: {},
        current_status: '',
        last_updated_date: new Date().toISOString().split('T')[0],
      };
    }

    if (!article.compliance_result.result) {
      article.compliance_result.result = {};
    }

    // 清除所有選項，然後設置選中的選項
    article.compliance_result.result.compliance = null;
    article.compliance_result.result.non_compliance = null;
    article.compliance_result.result.irrelevant = null;

    // 設置新值 - 使用類型斷言解決索引問題
    if (
      field === 'compliance' ||
      field === 'non_compliance' ||
      field === 'irrelevant'
    ) {
      article.compliance_result.result[field] = value;
    }

    // 更新日期
    article.compliance_result.last_updated_date = new Date()
      .toISOString()
      .split('T')[0];

    // 保存到服務器
    this.saveComplianceResult(article);

    // 更新此文章在 allArticles 中的對應記錄
    const articleIndex = this.allArticles.findIndex(
      (a) => a.article_id === article.article_id
    );

    if (articleIndex >= 0) {
      // 進行深拷貝或確保對象結構完整
      const updatedArticle = { ...this.allArticles[articleIndex] };

      // 確保 compliance_result 對象存在
      if (!updatedArticle.compliance_result) {
        updatedArticle.compliance_result = {
          result: { compliance: null, non_compliance: null, irrelevant: null },
          current_status: '',
          last_updated_date: '',
        };
      }

      // 確保 result 對象存在
      if (!updatedArticle.compliance_result.result) {
        updatedArticle.compliance_result.result = {
          compliance: null,
          non_compliance: null,
          irrelevant: null,
        };
      }

      // 更新結果
      updatedArticle.compliance_result.result = {
        ...updatedArticle.compliance_result.result,
        compliance: null,
        non_compliance: null,
        irrelevant: null,
      };

      // 設置新值 - 使用類型檢查解決索引問題
      if (
        field === 'compliance' ||
        field === 'non_compliance' ||
        field === 'irrelevant'
      ) {
        updatedArticle.compliance_result.result[
          field as keyof typeof updatedArticle.compliance_result.result
        ] = value;
      }

      updatedArticle.compliance_result.last_updated_date =
        article.compliance_result.last_updated_date;

      // 更新全部文章集合
      this.allArticles[articleIndex] = updatedArticle;

      // 重新計算總體統計數據
      this.calculateAllLawsStats();
    } else {
      console.warn('無法在全部文章集合中找到對應文章，統計數據可能不準確');
    }
  }

  // 保存合規性狀態
  saveComplianceStatus(article: any): void {
    // 更新日期
    article.compliance_result.last_updated_date = new Date()
      .toISOString()
      .split('T')[0];

    // 保存到服務器
    this.saveComplianceResult(article);

    // 更新 allArticles 中的對應文章
    const articleIndex = this.allArticles.findIndex(
      (a) => a.article_id === article.article_id
    );

    if (articleIndex >= 0) {
      // 確保對應的索引位置有 compliance_result 物件
      if (!this.allArticles[articleIndex].compliance_result) {
        this.allArticles[articleIndex].compliance_result = {
          result: { compliance: null, non_compliance: null, irrelevant: null },
          current_status: '',
          last_updated_date: '',
        };
      }

      this.allArticles[articleIndex].compliance_result.current_status =
        article.compliance_result.current_status;
      this.allArticles[articleIndex].compliance_result.last_updated_date =
        article.compliance_result.last_updated_date;

      // 更新總體統計
      // this.calculateAllLawsStats();
    }
  }

  // 添加 saveComplianceResult 方法
  saveComplianceResult(article: LawArticle): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.selectedLawDetails) {
        console.error('No law details selected, cannot save compliance result');
        reject('No law details selected');
        return;
      }

      console.log('Saving compliance result for article:', article);

      console.log("this.selectedTopic",this.selectedTopic);

      // 準備資料
      const data = {
        companyid: this.selectedCompanyId,
        topic: this.selectedTopic,
        title: this.selectedTitleFilter,
        law_id: this.selected_law_id,
        article_id: article.article_id,
        compliance_result: article.compliance_result,
      };

      console.log('Data to save:', data);

      this.http.post(`${this.apiUrl}/api/law_check_list/save_compliance_result`, data)
      .subscribe({
        next: (response: any) => {
          if (response.success) {
            console.log('合規結果保存成功:', response);
            resolve(response);
          } else {
            console.error('合規結果保存失敗:', response.error || response.message);
            reject(response.error || response.message);
          }
        },
        error: (error) => {
          console.error('保存合規結果時發生錯誤:', error);
          alert(`保存失敗: ${error.message || '未知錯誤'}`);
          reject(error);
        }
      });
    });
  }

  // 計算合規統計資料
  calculateComplianceStats(): void {
    // 重置計數器
    this.totalArticles = 0;
    this.compliantCount = 0;
    this.nonCompliantCount = 0;
    this.irrelevantCount = 0;
    this.pendingCount = 0; // 確保先將 pendingCount 重置為0

    // 遍歷所有文章計算統計數據（排除章節標題）
    this.selectedLawArticles.forEach((article) => {
      // 排除章節標題（article_type === 'C'）
      if (article.article_type === 'C') {
        return;
      }

      // 計算總數
      this.totalArticles++;

      // 根據合規結果分類
      if (article.compliance_result && article.compliance_result.result) {
        if (article.compliance_result.result.compliance === 'V') {
          this.compliantCount++;
        } else if (article.compliance_result.result.non_compliance === 'V') {
          this.nonCompliantCount++;
        } else if (article.compliance_result.result.irrelevant === 'V') {
          this.irrelevantCount++;
        } else {
          this.pendingCount++;
        }
      } else {
        this.pendingCount++;
      }
    });

    // 計算完成率
    if (this.totalArticles > 0) {
      const assessed = this.totalArticles - this.pendingCount;
      const rawRate = (assessed / this.totalArticles) * 100;

      // 只要有未判別項目，完成率最高只能顯示99%
      if (this.pendingCount > 0) {
        this.completionRate = Math.min(99, Math.round(rawRate));
      } else {
        // 只有當沒有未判別項目時，才允許顯示100%
        this.completionRate = Math.round(rawRate);
      }
    } else {
      this.completionRate = 0;
    }

    console.log('合規統計數據:', {
      總條數: this.totalArticles,
      符合: this.compliantCount,
      不符合: this.nonCompliantCount,
      不適用: this.irrelevantCount,
      尚未判別: this.pendingCount,
      完成率: this.completionRate,
    });
  }

  // 添加一個重置統計資料的方法
  resetComplianceStats(): void {
    this.totalArticles = 0;
    this.compliantCount = 0;
    this.nonCompliantCount = 0;
    this.irrelevantCount = 0;
    this.pendingCount = 0;
    this.completionRate = 0;
  }

  // 獲取狀態文字
  getStatusText(): string {
    if (this.completionRate === 100) {
      return '已完成';
    } else if (this.completionRate > 0) {
      return '進行中';
    } else {
      return '未開始';
    }
  }

  // 計算百分比
  getPercentage(count: number, total: number): number {
    if (total === 0) return 0;
    return Math.round((count / total) * 100);
  }

  // 收集寶箱方法 - 修改為立即顯示視窗並顯示載入狀態
  collectTreasure(index: number, requiredProgress: number): void {
    // 檢查是否達到所需進度
    if (this.completionRate >= requiredProgress) {
      // 根據不同進度設定不同的提示文字
      let inputText = '';

      switch (requiredProgress) {
        case 25:
          this.treasureModalTitle = '25% 達成獎勵 - 誇誇模式';
          this.treasureModalIcon = 'fa-face-laugh-beam';
          inputText =
            '誇我誇我，用你的聰明才智努力誇獎我，不用說 當然可以這一類的前贅詞';
          break;
        case 50:
          this.treasureModalTitle = '50% 達成獎勵 - 好友模式';
          this.treasureModalIcon = 'fa-thumbs-up';
          inputText =
            '給我一段溫暖且開心的話，跟我可以很開心，就像我的好死黨會跟我說的話。直接給我內容，不用說 當然可以這一類的前贅詞';
          break;
        case 75:
          this.treasureModalTitle = '75% 達成獎勵 - 笑話模式';
          this.treasureModalIcon = 'fa-heart';
          inputText =
            '給我一個好笑的笑話。直接給我內容，不用說 當然可以這一類的前贅詞';
          break;
        case 100:
          this.treasureModalTitle = '100% 達成獎勵 - 名人模式';
          this.treasureModalIcon = 'fa-trophy';
          inputText =
            '給我一個關於成功與勝利的經典名言，必須是知名人士所說的，並附上說這句話的人是誰以及他/她的成就。直接給我內容，不用說 當然可以這一類的前贅詞';
          break;
        default:
          this.treasureModalTitle = '寶箱獎勵';
          this.treasureModalIcon = 'fa-gift';
          inputText =
            '誇我誇我，用你的聰明才智努力誇獎我，不用說 當然可以這一類的前贅詞';
      }

      // 先顯示彈窗，並顯示載入狀態
      this.treasureContentLoading = true;
      this.treasureModalContent = '';
      this.showTreasureModal = true;


      // 調用 API 獲取內容
      this.openaiService
        .chatwithOpenAI(
          inputText,
          '', // assistantNo
          '', // response_id
          this.companyId, // companyid
          '',
          '' // vector_store_id
        )
        .subscribe({
          next: (response: any) => {

            // 設置彈窗內容並隱藏載入狀態
            this.treasureModalContent = response.content.replace(/\n/g, '<br>');
            this.treasureContentLoading = false;
          },
          error: (error) => {
            console.error('取得內容錯誤:', error);
            this.treasureModalContent = '無法取得寶箱內容，請稍後再試';
            this.treasureContentLoading = false;
          },
        });
    } else {
      // 提示用戶尚未達到進度
      alert(
        `您的完成度為 ${this.completionRate}%，尚未達到開啟此寶箱所需的 ${requiredProgress}% 進度。`
      );
    }
  }

  // 關閉彈窗
  closeTreasureModal(): void {
    this.showTreasureModal = false;
  }

  // 處理點擊彈窗背景
  onModalBackdropClick(event: MouseEvent): void {
    // 當點擊的是背景而非內容區域時關閉彈窗
    if (event.target === event.currentTarget) {
      this.closeTreasureModal();
    }
  }

  // 保存收集狀態
  saveTreasureCollectionState(): void {
    // 使用 localStorage 存儲收集狀態
    const key = `treasure_${this.companyId}_${this.selectedTopicFilter}_${this.selectedTitleFilter}`;
    localStorage.setItem(key, JSON.stringify(this.treasureCollected));
  }

  // 載入收集狀態
  loadTreasureCollectionState(): void {
    const key = `treasure_${this.companyId}_${this.selectedTopicFilter}_${this.selectedTitleFilter}`;
    const savedState = localStorage.getItem(key);

    if (savedState) {
      this.treasureCollected = JSON.parse(savedState);
    } else {
      this.treasureCollected = [false, false, false, false];
    }
  }

  // 切換統計區域的可見性
  toggleStatsVisibility(): void {
    this.isStatsVisible = !this.isStatsVisible;

    // 存儲用戶的偏好設置
    localStorage.setItem(
      'stats_visible_preference',
      this.isStatsVisible.toString()
    );
  }

  // 批次應用狀態到所有未判別的項目
  async applyBatchStatus(): Promise<void> {
    if (!this.batchStatus || !this.selectedLawArticles) {
      return;
    }

    if (
      !confirm(
        `確定要將所有未判別的法條批次設定為「${this.getBatchStatusDisplay(
          this.batchStatus
        )}」嗎？`
      )
    ) {
      return;
    }

    // 收集所有未判別項目的儲存 promise
    const savePromises: Promise<any>[] = [];
    this.selectedLawArticles.forEach((article) => {
      // 排除章節標題
      if (article.article_type === 'C') {
        return;
      }

      const hasResult =
        article.compliance_result?.result?.compliance === 'V' ||
        article.compliance_result?.result?.non_compliance === 'V' ||
        article.compliance_result?.result?.irrelevant === 'V';

      if (!hasResult) {
        // 先更新狀態
        this.updateComplianceResult(article, this.batchStatus, 'V');
        // 直接呼叫 saveComplianceResult 並收集 promise
        savePromises.push(this.saveComplianceResult(article));
      }
    });

    this.batchStatus = '';

    // 等待所有儲存完成再刷新列表
    await Promise.all(savePromises);
    this.reloaddata(); // 或 this.loadTaskList();
  }

  // 獲取批次狀態的顯示名稱
  getBatchStatusDisplay(status: string): string {
    switch (status) {
      case 'compliance':
        return '符合';
      case 'non_compliance':
        return '不符合';
      case 'irrelevant':
        return '不適用';
      default:
        return '未知';
    }
  }

  // 批次寫入目前狀態
  applyBatchCurrentStatus(): void {
    if (
      !this.batchCurrentStatus ||
      !this.batchCurrentStatus.trim() ||
      !this.selectedLawArticles
    ) {
      return;
    }

    // 確認對話框
    const statusText = this.batchCurrentStatus.trim();
    if (!confirm(`確定要將所有法條的目前狀態批次設定為「${statusText}」嗎？`)) {
      return;
    }

    // 遍歷所有法條（排除章節標題）
    let updatedCount = 0;
    this.selectedLawArticles.forEach((article) => {
      // 排除章節標題
      if (article.article_type === 'C') {
        return;
      }

      // 確保 compliance_result 存在
      if (!article.compliance_result) {
        article.compliance_result = {
          result: { compliance: null, non_compliance: null, irrelevant: null },
          current_status: '',
          last_updated_date: '',
        };
      }

      // 更新目前狀態
      article.compliance_result.current_status = statusText;
      article.compliance_result.last_updated_date = new Date()
        .toISOString()
        .split('T')[0];

      // 保存到服務器
      this.saveComplianceResult(article);
      updatedCount++;

      // 更新 allArticles 中的對應記錄
      const articleIndex = this.allArticles.findIndex(
        (a) => a.article_id === article.article_id
      );

      if (articleIndex >= 0) {
        // 確保 compliance_result 存在
        if (!this.allArticles[articleIndex].compliance_result) {
          this.allArticles[articleIndex].compliance_result = {
            result: {
              compliance: null,
              non_compliance: null,
              irrelevant: null,
            },
            current_status: '',
            last_updated_date: '',
          };
        }

        // 更新狀態
        this.allArticles[articleIndex].compliance_result.current_status =
          statusText;
        this.allArticles[articleIndex].compliance_result.last_updated_date =
          new Date().toISOString().split('T')[0];
      }
    });

    // 顯示更新結果
    alert(`已將 ${updatedCount} 條法規的目前狀態更新為「${statusText}」`);

    // 重置輸入
    this.batchCurrentStatus = '';

    // 更新統計數據
    // this.calculateAllLawsStats();
  }

  // AI智能判斷
  runAiAnalysis(): void {
    alert('AI智能判斷');
    // 顯示載入中
  }

  // 清空所有判別結果
  async clearAllResults(): Promise<void> {
    if (!confirm('確定要清空當前選取法規的所有判別結果嗎？此操作無法復原！')) {
      return;
    }
    if (
      !confirm(
        '再次確認：這將刪除目前選取法規的所有已設定結果，包括符合、不符合和不適用的標記以及狀態說明。'
      )
    ) {
      return;
    }

    this.isClearingAll = true;
    try {

      // 逐一儲存每個法條的結果（同步執行，避免 forEach+async 問題）
      let errors: string[] = [];
      for (const article of this.selectedLawArticles) {
        // 排除章節標題
        if (article.article_type === 'C') {
          continue;
        }

        article.compliance_result = {
          result: {
            compliance: null,
            non_compliance: null,
            irrelevant: null,
          },
          current_status: '',
          last_updated_date: new Date().toISOString().split('T')[0],
        };
        try {
          await this.saveComplianceResult(article);
        } catch (error) {
          let msg = '';
          if (typeof error === 'string') {
            msg = error;
          } else if (error && typeof error === 'object' && 'message' in error) {
            msg = (error as any).message;
          } else {
            msg = JSON.stringify(error);
          }
          errors.push(`法條ID: ${article.article_id} 儲存失敗: ${msg}`);
        }
      }

      if (errors.length === 0) {
      } else {
        alert("清空時有部分資料儲存失敗：\n" + errors.join('\n'));
      }

      //重新計算統計資料
      this.calculateAllLawsStats(); // 只刷新資料，統計交由資料撈回後統一處理
    } finally {
      this.isClearingAll = false;
    }
  }

  // Method to load distinct information from API
  loadDistinctInfo() {
    this.http
      .get<any>(`${this.apiUrl}/api/law_check_list/getdisctinctinfo`)
      .subscribe({
        next: (response) => {
          if (response && response.success && response.data) {
            this.distinctInfo = response.data;
            console.log('Loaded distinct info:', this.distinctInfo);
            // 預設選擇第一個主題
            const topics = this.getAvailableTopics();
            if (topics.length > 0) {
              this.selectedTopicFilter = topics[0];
              // 直接觸發主題變更事件
              this.onTopicChange();
            }
          } else {
            console.error('Failed to load distinct info:', response);
          }
        },
        error: (error) => {
          console.error('Error loading distinct info:', error);
        },
      });
  }

// getDistinctCompanies(): CompanyOption[] {
//   if (!this.distinctInfo || this.distinctInfo.length === 0) return [];

//   // Create a Map to store unique companies with their IDs as keys
//   const companiesMap = new Map<string, string>();

//   // Populate the map with company IDs
//   this.distinctInfo
//     .filter(item => item.companyid) // Filter out items without companyid
//     .forEach(item => {
//       // Only add if not already in the map
//       if (!companiesMap.has(item.companyid)) {
//         companiesMap.set(item.companyid, item.companyid); // Initially, we use the ID as both key and display name
//       }
//     });

//   // Convert Map to an array of CompanyOption objects
//   const companies: CompanyOption[] = Array.from(companiesMap).map(([id, name]) => ({
//     id: id,
//     name: this.getCompanyDisplayName(id) // Use helper method to get display name
//   }));

//   console.log('Distinct companies:', companies);

//   return companies;
// }

// Helper method to get a display name for a company ID
// private getCompanyDisplayName(id: string): string {
//   // Map company IDs to display names
//   switch (id) {
//     case 'giant':
//       return '祐昕技術顧問';
//     case '優乃克':
//       return '祐昕學院';
//     case '安順':
//       return '佶昕智能';
//     case '三化電子':
//       return '大佶企業';
//     default:
//       return id; // Return the ID itself if no mapping exists
//   }
// }

  // Get available topics based on selected company
  getAvailableTopics(): string[] {
    if (!this.selectedCompanyId || !this.distinctInfo) return [];

    // Filter items for the selected company and extract unique topics
    const topicsSet = new Set(
      this.distinctInfo
        .filter(
          (item) => item.companyid === this.selectedCompanyId && item.topic
        )
        .map((item) => item.topic)
    );

    const topics = Array.from(topicsSet);

    // 在開頭加入「所有主題」選項
    return ['所有主題', ...topics];
  }

  // Get available titles based on selected company and topic
  getAvailableTitles(): string[] {
    if (
      !this.selectedCompanyId ||
      !this.selectedTopicFilter ||
      !this.distinctInfo
    )
      return [];

    // 如果選擇的是「所有主題」，則只按公司篩選
    const filterCondition = this.selectedTopicFilter === '所有主題'
      ? (item: any) => item.companyid === this.selectedCompanyId && item.title
      : (item: any) => item.companyid === this.selectedCompanyId &&
                       item.topic === this.selectedTopicFilter &&
                       item.title;

    // Filter items for the selected company and topic, then extract unique titles
    const titlesSet = new Set(
      this.distinctInfo
        .filter(filterCondition)
        .map((item) => item.title)
    );

    return Array.from(titlesSet);
  }

  // 原有的 onFilterChange 只處理重置
onFilterChange() {
  // 重置標題和數據顯示狀態
  this.selectedTitleFilter = '';
  this.dataLoaded = false;
  this.tasksLoaded = false;
}

  // 新增載入任務列表方法
  loadTaskList() {
    if (!this.selectedCompanyId || !this.selectedTopicFilter) {
      alert('請選擇公司和主題');
      return;
    }

    // 顯示載入中
    this.tasksLoaded = false;

    // 準備 API 參數
    const params: any = {
      companyid: this.selectedCompanyId
    };

    // 如果不是「所有主題」，則加入主題篩選條件
    if (this.selectedTopicFilter !== '所有主題') {
      params.topic = this.selectedTopicFilter;
    }

    // 呼叫 API 獲取任務列表
    this.http.get<any>(`${this.apiUrl}/api/law_check_list/get_check_lists`, {
      params: params
    }).subscribe({
      next: (response) => {


        console.log('載入任務列表:', response);

         if (response && response.success) {
      // 處理任務列表 - 轉換日期、計算完成率等
      this.availableTasks = response.data.map((task: any) => {
        const complianceRates = this.calculateComplianceRates(task);
        return {
          ...task,
          // 保留原始資料，並添加處理後的資料
          startDate: task.startDate || task.start_date,
          endDate: task.endDate || task.end_date,
          title: task.title,
          // 顯示法規數和法條數
          lawCount: task.law_count || 0,
          articleCount: task.article_count || 0,
          // 相關部門
          departments: task.departments || [],
          // 進度
          process:response.process || {},
          completionRate: this.calculateCompletionRate(task),
          // 法規符合度資訊
          complianceRates: complianceRates,
          id: task.id || task.mission_id,
          // 備註
          note: task.note || ''
        };



      });

      // 使用新的篩選功能
      this.updateTaskListWithFilters(this.availableTasks);

      this.tasksLoaded = true;
      this.dataLoaded = false; // 確保查核內容不顯示
    } else {
      alert('載入任務列表失敗: ' + (response.message || '未知錯誤'));
    }
      },
      error: (err) => {
        console.error('載入任務列表失敗', err);
        alert('載入任務列表失敗，請稍後再試');
      }
    });
  }

  // 選擇任務，載入查核內容
  selectTask(task: any) {

    //這邊一定要把selectedTopic載入，否則會造成錯誤
    this.selectedTopic = task.topic;

    // 設定舊的 isTaskLoading 為 true (保持向後相容)
    this.isTaskLoading = true;

    try {
      // Store the selected task
      this.selectedTask = task;
      this.selectedTitleFilter = task.title;
      this.loadData(task.id, task); // 修改 loadData 方法以接受 taskId 參數

      // 移除人工延遲，因為 loadData 現在已經有適當的 loading 指示器
      // loadData 完成後會自動設定 dataLoaded = true 和 isLoading = false
    } catch (error) {
      console.error('Error loading task data:', error);
      this.isTaskLoading = false; // Make sure to hide loading on error
      this.isLoading = false; // 確保錯誤時也關閉 loading

      // Optionally show an error message to the user
    }
  }

  // 修改 loadData 方法以接受任務 ID
// 修改 loadData 方法以接受任務 ID
loadData(taskId?: string, task?:any) {

  // 設定 loading 狀態
  this.isLoading = true;
  // 顯示載入中
  this.dataLoaded = false;

  // 如果沒有足夠參數，則退出
  if (!this.selectedCompanyId || !this.selectedTopicFilter || !this.selectedTitleFilter) {
    if (!taskId) {
      console.error('無法載入資料：缺少必要參數');
      this.isLoading = false; // 確保錯誤時也關閉 loading
      return;
    }
  }

  // 準備請求參數
  const params: any = {
    companyid: this.selectedCompanyId,
    title: this.selectedTitleFilter,
  };

  // 如果有傳入 task 參數，使用 task 的 topic
  if (task && task.topic) {
    params.topic = task.topic;
  } else if (this.selectedTopicFilter !== '所有主題') {
    // 如果沒有 task 參數且不是「所有主題」，則使用 selectedTopicFilter
    params.topic = this.selectedTopicFilter;
  }

  // 如果提供了 taskId，則使用它
  if (taskId) {
    params.mission_id = taskId;
  }

  console.log('載入查核資料，參數:', params);

  // 先載入法規列表
  this.http.get<any>(`${this.apiUrl}/api/law_check_list/get_compliance_regulation_and_result_all`, { params })
    .subscribe({
      next: (response: any) => {
        try {
          if (response) {

            console.log('法規列表載入成功:', response);

            this.alldata = response.data || [];
            this.filteredData = this.alldata; // 初始化過濾資料

            console.log('法規列表:', this.alldata);

            this.reloaddata();

            // 顯示資料
            this.dataLoaded = true;
            this.tasksLoaded = false; // 隱藏任務列表
          } else {
            console.error('法規列表載入失敗:', response.message || '未知錯誤');
            alert('法規列表載入失敗: ' + (response.message || '未知錯誤'));
          }
        } finally {
          // 無論成功或失敗都要關閉 loading
          this.isLoading = false;
          this.isTaskLoading = false; // 同時重置舊的 loading 狀態
        }
      },
      error: (err) => {
        console.error('載入法規列表時發生錯誤:', err);
        alert('載入法規列表失敗，請稍後再試');
        // 錯誤時也要關閉 loading
        this.isLoading = false;
        this.isTaskLoading = false; // 同時重置舊的 loading 狀態
      }
    });
}

reloaddata() {


          this.lawsWithCount = this.processLawsWithCount(this.filteredData) || [];

          // 如果有法規，選擇第一個並載入其詳細資料
          if (this.lawsWithCount.length > 0) {
            this.selected_law_id = this.lawsWithCount[0].law_id;
            this.load_compliance_detail();
          }

          this.loadAllLawsStatistics();

}




processLawsWithCount(apiResponse: any): { law_id: string; cnt: number }[] {
  if (!apiResponse) {
    return [];
  }

  console.log('處理法規列表:', apiResponse);

  return apiResponse
    .map((item: any) => {
      // 兼容不同資料結構
      const law = item.laws || item.law || item;
      const law_id = law.law_id || item.law_id;
      const articles = law.law_articles || item.law_articles || [];
      const cnt = articles.length || item.cnt || 0;
      return {
        law_id,
        cnt,
      };
    })
    .filter((law: { law_id: string; cnt: number }) => law.cnt > 0); // 只保留有條文的法規
}
  // 返回任務列表
  backToTaskList() {
    this.dataLoaded = false;
    this.tasksLoaded = true;
    // 可能需要清空一些查核相關的狀態
    this.loadTaskList();
  }

  // 計算任務完成率的輔助方法 (如果後端沒提供)
 private calculateCompletionRate(task: any): number {
  if (!task.process || !task.process.total_count || task.process.total_count === 0) {
    return 0;
  }

  // 計算已評估的法條數量 (符合 + 不符合 + 不適用)
  const assessedCount = (task.process.compliance_count || 0) +
                       (task.process.non_compliance_count || 0) +
                       (task.process.irrelevant_count || 0);

  // 計算未判別數量
  const pendingCount = task.process.total_count - assessedCount;

  // 計算完成率百分比
  const rawRate = (assessedCount / task.process.total_count) * 100;

  // 只要有未判別項目，完成率最高只能顯示99%
  if (pendingCount > 0) {
    return Math.min(99, Math.round(rawRate));
  } else {
    // 只有當沒有未判別項目時，才允許顯示100%
    return Math.round(rawRate);
  }
}

  // 計算任務法規符合度的輔助方法
  private calculateComplianceRates(task: any): any {
    if (!task.process || !task.process.total_count || task.process.total_count === 0) {
      return {
        complianceRate: 0,
        nonComplianceRate: 0,
        irrelevantRate: 0,
        pendingRate: 100,
        complianceCount: 0,
        nonComplianceCount: 0,
        irrelevantCount: 0,
        pendingCount: task.process?.total_count || 0,
        totalCount: task.process?.total_count || 0
      };
    }

    const totalCount = task.process.total_count;
    const complianceCount = task.process.compliance_count || 0;
    const nonComplianceCount = task.process.non_compliance_count || 0;
    const irrelevantCount = task.process.irrelevant_count || 0;
    const pendingCount = totalCount - complianceCount - nonComplianceCount - irrelevantCount;

    return {
      complianceRate: Math.round((complianceCount / totalCount) * 100),
      nonComplianceRate: Math.round((nonComplianceCount / totalCount) * 100),
      irrelevantRate: Math.round((irrelevantCount / totalCount) * 100),
      pendingRate: Math.round((pendingCount / totalCount) * 100),
      complianceCount,
      nonComplianceCount,
      irrelevantCount,
      pendingCount,
      totalCount
    };
  }

  // Check if data can be loaded
  canLoadData(): boolean {
    // At minimum, we need company and topic to load data
    return this.selectedCompanyId !== '' && this.selectedTopicFilter !== '';
  }

  // 當輸入框獲得焦點時，存儲原始狀態
  storeOriginalStatus(article: LawArticle): void {
    this.originalStatusMap.set(article.article_id, article.compliance_result?.current_status || '');
  }

  // 當輸入框失去焦點時，檢查狀態是否變化
  checkStatusChanged(article: LawArticle): void {
    const originalStatus = this.originalStatusMap.get(article.article_id) || '';
    const currentStatus = article.compliance_result?.current_status || '';

    // 只有當狀態發生變化時才保存
    if (originalStatus !== currentStatus) {
      console.log(`狀態已變更: "${originalStatus}" -> "${currentStatus}"`);
      this.saveComplianceStatus(article);
    } else {
      console.log('狀態未變更，不執行保存');
    }
  }


  onTopicChange() {
    if (this.selectedTopicFilter) {
      this.selectedTitleFilter = '';
      this.dataLoaded = false;
      // 自動載入任務列表
      this.loadTaskList();
    }
  }


// 在 compliance-list.component.ts 中添加這個方法
getTaskStatus(task: any): {status: string, className: string} {
  // 檢查任務狀態是否為 review (待審核)
  if (task.status === 'review') {
    return { status: '待審核', className: 'under-review' };
  }

  // 檢查任務狀態是否為 approved (審核通過)
  if (task.status === 'approved') {
    return { status: '審核通過', className: 'approved' };
  }

  // 檢查任務狀態是否為 reject (審核不通過)
  if (task.status === 'reject') {
    return { status: '審核不通過', className: 'rejected' };
  }

  const today = new Date();
  const startDate = task.startDate ? new Date(task.startDate) : null;
  const endDate = task.endDate ? new Date(task.endDate) : null;

  // 如果完成率達到 100%，視為已完成
  if (task.completionRate === 100) {
    return { status: '已完成', className: 'completed' };
  }

  // 如果沒有開始日期或結束日期，則為"未設定"
  if (!startDate || !endDate) {
    return { status: '日期未設定', className: 'undefined' };
  }

  // 已過結束日期但未完成
  if (today > endDate) {
    return { status: '已逾期', className: 'overdue' };
  }

  // 還未到開始日期
  if (today < startDate) {
    return { status: '尚未開始', className: 'not-started' };
  }

  // 在開始和結束日期之間
  return { status: '進行中', className: 'in-progress' };
}

filterByStatus(status: 'all' | 'compliance' | 'non_compliance' | 'irrelevant' | 'pending') {
  this.selectedStatusFilter = status;

  // 清空選擇的法規和法條
  this.selectedLawDetails = null;
  this.selectedLawArticles = [];

  if (status === 'all') {
    // 全部顯示
    this.filteredData = [...this.alldata];
  } else {
    // 依據狀態過濾每個法規的法條
    this.filteredData = this.alldata
      .map(item => {
        const articles = item.laws?.law_articles || [];
        let filteredArticles: LawArticle[] = [];

        if (status === 'compliance') {
          filteredArticles = articles.filter(
             (a: LawArticle) => a.article_type !== 'C' && a.compliance_result?.result?.compliance === 'V'
          );
        } else if (status === 'non_compliance') {
          filteredArticles = articles.filter(
             (a: LawArticle) => a.article_type !== 'C' && a.compliance_result?.result?.non_compliance === 'V'
          );
        } else if (status === 'irrelevant') {
          filteredArticles = articles.filter(
             (a: LawArticle) => a.article_type !== 'C' && a.compliance_result?.result?.irrelevant === 'V'
          );
        } else if (status === 'pending') {
          filteredArticles = articles.filter(
             (a: LawArticle) =>
              a.article_type !== 'C' &&
              a.compliance_result &&
              a.compliance_result.result &&
              a.compliance_result.result.compliance !== 'V' &&
              a.compliance_result.result.non_compliance !== 'V' &&
              a.compliance_result.result.irrelevant !== 'V'
          );
        }

        // 回傳只包含符合條件法條的法規
        return {
          ...item,
          laws: {
            ...item.laws,
            law_articles: filteredArticles
          }
        };
      })
      // 只保留有符合條件法條的法規
      .filter(item => item.laws?.law_articles?.length > 0);
  }

  console.log('過濾後的資料:', this.filteredData);

  this.reloaddata();


}

exportToExcel(): void {
  if (!this.filteredData || this.filteredData.length === 0) {
    alert('沒有可匯出的資料');
    return;
  }

  const totalCount = this.filteredData.length;

  if (!confirm(`即將匯出 ${totalCount} 筆資料，是否繼續？`)) {
    return;
  }

    const today = new Date();
  const yyyymmdd = today.getFullYear().toString() +
    String(today.getMonth() + 1).padStart(2, '0') +
    String(today.getDate()).padStart(2, '0');
  const taskName = this.selectedTitleFilter ? this.selectedTitleFilter.replace(/[\\/:*?"<>|]/g, '') : '任務名稱';
  const filename = `${yyyymmdd} ${taskName}_合規性判斷.xlsx`;



  this.http.post(`${this.apiUrl}/api/law_check_list/export_excel`, this.filteredData, {
    responseType: 'blob'
  }).subscribe({
    next: (blob: Blob) => {
      // 建立下載連結
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    error: (err) => {
      console.error('匯出 Excel 失敗:', err);
      alert('匯出 Excel 失敗，請稍後再試');
    }
  });

}

// 編輯任務（暫時為佔位）
  onEditTask(task: any): void {
    // TODO: 實作編輯功能
    alert('編輯功能尚未實作');
  }

  // 刪除任務
  onDeleteTask(task: any): void {
    const input = window.prompt(`請輸入任務名稱以確認刪除：「${task.title}」`);
    if (input === null) return; // 使用者取消
    if (input.trim() !== task.title) {
      alert('輸入的任務名稱不正確，刪除已取消。');
      return;
    }

    // 呼叫刪除 API
    this.isDeleting = true;
    const body = {
      companyid: task.companyid,
      topic: task.topic,
      title: task.title
    };
    this.http.post(`${this.apiUrl}/api/law_check_list/delete_mission`, body).subscribe({
      next: (res: any) => {
        this.isDeleting = false;
        if (res.success) {
          alert('刪除成功');
          // Remove the deleted task from availableTasks
          this.availableTasks = this.availableTasks.filter(
            t => !(t.companyid === task.companyid && t.topic === task.topic && t.title === task.title)
          );
          // Also remove from filteredData if present
          this.filteredData = this.filteredData.filter(
            t => !(t.companyid === task.companyid && t.topic === task.topic && t.title === task.title)
          );
        } else {
          alert('刪除失敗: ' + (res.message || '未知錯誤'));
        }
      },
      error: (err) => {
        this.isDeleting = false;
        alert('刪除失敗: ' + (err.error?.message || err.message || '未知錯誤'));
      }
    });
  }

  // 重置 Summary 資料
  private resetSummaryData(): void {
    this.selectedLawSummary = '';
    this.summaryLastUpdated = '';
    this.summaryUpdatedBy = '';
  }


  // 儲存法規 Summary
  saveLawSummary(): void {
    if (!this.selected_law_id || !this.selectedCompanyId || !this.selectedTopic || !this.selectedTitleFilter) {
      alert('缺少必要參數，無法儲存 Summary');
      return;
    }

    // 基本驗證 - 檢查是否有輸入內容
    if (!this.selectedLawSummary || this.selectedLawSummary.trim() === '') {
      alert('請輸入 Summary 內容');
      return;
    }

    this.isSummaryLoading = true;

    // 準備儲存資料 - 使用特殊的 article_id = "summary"
    const data = {
      companyid: this.selectedCompanyId,
      topic: this.selectedTopic,
      title: this.selectedTitleFilter,
      law_id: this.selected_law_id,
      assign_to: this.selectedTask?.assign_to || '', // 使用選擇的任務分配人
      article_id: 'summary',
      mission_id: this.selectedTask?.id || '', // 使用選擇的任務 ID
      summary_text: this.selectedLawSummary.trim(),
      last_updated_date: new Date().toISOString().split('T')[0],
      updated_by: this.authService.getUserInfo().username

    };


    // 呼叫儲存 API
    this.http.post(`${this.apiUrl}/api/law_check_list/save_law_summary`, data)
      .subscribe({
        next: (response: any) => {
          this.isSummaryLoading = false;
          if (response.success) {
            console.log('法規 Summary 儲存成功:', response);
            // 更新本地資料
            this.summaryLastUpdated = data.last_updated_date;
            this.summaryUpdatedBy = data.updated_by;

            // 更新 selectedLawDetails 中的 summary 資料
            if (this.selectedLawDetails && this.selectedLawDetails.laws) {
              if (!this.selectedLawDetails.laws.summary) {
                this.selectedLawDetails.laws.summary = {
                  summary_text: '',
                  updatedBy: '',
                  updatedDate: ''
                };
              }
              this.selectedLawDetails.laws.summary.summary_text = data.summary_text;
              this.selectedLawDetails.laws.summary.updatedBy = data.updated_by;
              this.selectedLawDetails.laws.summary.updatedDate = data.last_updated_date;
            }

            // 同時更新 filteredData 中對應的法規資料，保持資料一致性
            if (this.filteredData && this.filteredData.length > 0) {
              const targetLaw = this.filteredData.find(item =>
                item.laws && item.laws.law_id === this.selected_law_id
              );
              if (targetLaw && targetLaw.laws) {
                if (!targetLaw.laws.summary) {
                  targetLaw.laws.summary = {
                    summary_text: '',
                    updatedBy: '',
                    updatedDate: ''
                  };
                }
                targetLaw.laws.summary.summary_text = data.summary_text;
                targetLaw.laws.summary.updatedBy = data.updated_by;
                targetLaw.laws.summary.updatedDate = data.last_updated_date;
              }
            }

            alert('法規 Summary 儲存成功');
          } else {
            console.error('法規 Summary 儲存失敗:', response.error || response.message);
            alert('儲存失敗: ' + (response.error || response.message || '未知錯誤'));
          }
        },
        error: (error) => {
          this.isSummaryLoading = false;
          console.error('儲存法規 Summary 時發生錯誤:', error);
          alert('儲存失敗: ' + (error.error?.message || error.message || '未知錯誤'));
        }
      });
  }

  // 處理 Summary 文字框的鍵盤事件 (支援 Ctrl+S 快捷鍵)
  onSummaryKeyDown(event: KeyboardEvent): void {
    // 檢查是否按下 Ctrl+S (Windows/Linux) 或 Cmd+S (Mac)
    if ((event.ctrlKey || event.metaKey) && event.key === 's') {
      event.preventDefault(); // 防止瀏覽器預設的儲存行為
      this.saveLawSummary();
    }
  }

  // 任務結案功能
  onCloseTask(): void {
    // 確認對話框
    if (confirm('確定要結案此任務嗎？結案後任務狀態將變更為待審核。')) {
      this.closeTask();
    }
  }

  // 執行任務結案的方法
  private closeTask(): void {
    if (!this.selectedTask?.id) {
      alert('錯誤：無法取得任務資訊');
      return;
    }

    // 準備API請求資料
    const updateData = {
      companyid: environment.companyid,
      id: this.selectedTask.id,
      status: 'review',
      approval_history: {
        action: 'submit_review',
        text: this.authService.getUserInfo().username,
        date: new Date().toISOString()
      }
    };

    console.log('發送任務結案請求:', updateData);

    // 調用API更新任務狀態
    const url = `${this.apiUrl}/api/law_check_list/law-check-info/update`;

    this.http.post(url, updateData).subscribe({
      next: (response: any) => {
        console.log('任務結案成功:', response);

        if (response.success) {
          alert('任務結案成功！狀態已更新為待審核。');

          // 更新本地任務狀態
          if (this.selectedTask) {
            this.selectedTask.status = 'review';
          }

          // 重新載入任務列表以反映狀態變更
          this.loadTaskList();

        } else {
          console.error('任務結案失敗:', response.message);
          alert('任務結案失敗: ' + (response.message || '未知錯誤'));
        }
      },
      error: (error) => {
        console.error('任務結案API調用失敗:', error);
        alert('任務結案失敗: ' + (error.error?.message || error.message || '網路錯誤'));
      }
    });
  }

  // 更新任務狀態的通用方法
  private updateTaskStatus(newStatus: string, action: string = 'status_update', actionText: string = this.authService.getUserInfo().username): void {
    // if (!this.selectedTask?.id) {
    //   console.error('錯誤：無法取得任務資訊');
    //   return;
    // }

    // // 準備API請求資料
    // const updateData = {
    //   companyid: environment.companyid,
    //   id: this.selectedTask.id,
    //   status: newStatus,
    //   approval_history: {
    //     action: action,
    //     text: actionText,
    //     date: new Date().toISOString()
    //   }
    // };

    // console.log('更新任務狀態請求:', updateData);

    // // 調用API更新任務狀態
    // const url = `${this.apiUrl}/api/regulation/law-check-info/update`;

    // this.http.post(url, updateData).subscribe({
    //   next: (response: any) => {
    //     console.log('任務狀態更新成功:', response);

    //     if (response.success) {
    //       // 更新本地任務狀態
    //       if (this.selectedTask) {
    //         this.selectedTask.status = newStatus;
    //       }

    //       // 重新載入任務列表以反映狀態變更
    //       this.loadTaskList();

    //     } else {
    //       console.error('任務狀態更新失敗:', response.message);
    //       throw new Error(response.message || '更新失敗');
    //     }
    //   },
    //   error: (error) => {
    //     console.error('任務狀態更新API調用失敗:', error);
    //     throw error;
    //   }
    // });
  }

  // 審核任務功能
  onReviewTask(task: any): void {
    // 確認是否要進行審核
    const confirmMessage = `確定要審核任務「${task.title || task.topic}」嗎？`;
    if (confirm(confirmMessage)) {
      this.reviewTask(task);
    }
  }

  // 執行任務審核的方法
  private reviewTask(task: any): void {
    // TODO: 實作任務審核邏輯
    // 這裡將會開啟審核對話框或跳轉至審核頁面
    console.log('任務審核功能將在後續實作:', task);

    // 暫時顯示提示訊息
    alert(`任務「${task.title || task.topic}」的審核功能將在後續實作`);

    // 將來這裡可能會：
    // 1. 開啟審核模態視窗
    // 2. 跳轉至專門的審核頁面
    // 3. 調用審核 API
  }

  // 審核通過按鈕事件
  onReviewApprove(): void {
    this.reviewType = 'approve';
    this.reviewModalTitle = '審核通過確認';
    this.reviewComment = '';
    this.includeImprovementItems = false;

    // 計算不符合項目數量
    this.nonComplianceCount = this.calculateNonComplianceCount();

    this.showReviewModal = true;
  }

  // 審核不通過按鈕事件
  onReviewReject(): void {
    this.reviewType = 'reject';
    this.reviewModalTitle = '審核不通過確認';
    this.reviewComment = '';
    this.showReviewModal = true;
  }

  // 關閉審核模態視窗
  closeReviewModal(): void {
    this.showReviewModal = false;
    this.reviewComment = '';
    this.reviewType = 'approve';
    this.reviewModalTitle = '';
    this.includeImprovementItems = false;
    this.nonComplianceCount = 0;
  }

  // 確認審核
  confirmReview(): void {
    if (!this.reviewComment.trim()) {
      alert('請輸入審核意見');
      return;
    }

    const action = this.reviewType === 'approve' ? '通過' : '不通過';
    let confirmMessage = `確定要${action}此任務嗎？\n\n審核意見：${this.reviewComment}`;

    // 如果是審核通過且選擇拋轉改善項目，添加額外確認資訊
    if (this.reviewType === 'approve' && this.includeImprovementItems && this.nonComplianceCount > 0) {
      confirmMessage += `\n\n將同時拋轉 ${this.nonComplianceCount} 筆不符合項目到改善追蹤清單。`;
    }

    if (confirm(confirmMessage)) {
      // 如果是審核通過且選擇拋轉改善項目，先處理改善項目
      if (this.reviewType === 'approve' && this.includeImprovementItems && this.nonComplianceCount > 0) {
        this.processImprovementItemsTransfer().then(() => {
          this.processReview();
        }).catch((error: any) => {
          console.error('處理改善項目拋轉失敗:', error);
          alert('改善項目拋轉失敗: ' + error.message);
        });
      } else {
        this.processReview();
      }
    }
  }

  // 處理審核流程
  private processReview(): void {
    const reviewData = {
      taskId: this.selectedTask?.id,
      reviewType: this.reviewType,
      reviewComment: this.reviewComment,
      reviewBy: this.authService.getUserInfo().username,
      reviewDate: new Date().toISOString(),
      // 審核通過時的改善項目設定
      includeImprovementItems: this.reviewType === 'approve' ? this.includeImprovementItems : false,
      nonComplianceCount: this.reviewType === 'approve' ? this.nonComplianceCount : 0
    };

    console.log('審核資料:', reviewData);

    // TODO: 調用 API 處理審核
    if (this.reviewType === 'approve') {
      this.processApproval(reviewData);
    } else {
      this.processRejection(reviewData);
    }

    // 關閉模態視窗
    this.closeReviewModal();
  }

  // 處理審核通過
  private processApproval(reviewData: any): void {
    try {
      // 準備審核通過的API請求資料
      const updateData = {
        companyid: environment.companyid,
        id: this.selectedTask?.id,
        status: 'approved', // 審核通過，狀態設為已完成
        approval_history: {
          action: 'approve_review',
          text: `${reviewData.reviewBy} - ${reviewData.reviewComment}`,
          date: reviewData.reviewDate
        }
      };

      console.log('發送審核通過請求:', updateData);

      // 調用API更新任務狀態
      const url = `${this.apiUrl}/api/law_check_list/law-check-info/update`;

      this.http.post(url, updateData).subscribe({
        next: (response: any) => {
          console.log('審核通過成功:', response);

          if (response.success) {
            let message = '審核通過處理完成！任務狀態已更新為審核完成。';

            // 如果選擇了包含改善項目
            if (reviewData.includeImprovementItems && reviewData.nonComplianceCount > 0) {
              message += `\n\n同時將 ${reviewData.nonComplianceCount} 筆不符合項目轉為改善項目。`;
              // TODO: 調用 API 創建改善項目
              this.createImprovementItems(reviewData);
            }

            alert(message);

            // 更新本地任務狀態
            if (this.selectedTask) {
              this.selectedTask.status = 'completed';
            }

            // 重新載入任務列表
            this.loadTaskList();

          } else {
            console.error('審核通過失敗:', response.message);
            alert('審核通過失敗: ' + (response.message || '未知錯誤'));
          }
        },
        error: (error) => {
          console.error('審核通過API調用失敗:', error);
          alert('審核通過失敗: ' + (error.error?.message || error.message || '網路錯誤'));
        }
      });

    } catch (error) {
      console.error('審核通過處理失敗:', error);
      alert('審核通過處理失敗: ' + (error instanceof Error ? error.message : '未知錯誤'));
    }
  }

  // 處理審核不通過
  private processRejection(reviewData: any): void {
    try {
      // 準備審核不通過的API請求資料
      const updateData = {
        companyid: environment.companyid,
        id: this.selectedTask?.id,
        status: 'reject', // 退回給負責部門，狀態設為進行中
        approval_history: {
          action: 'reject_review',
          text: `${reviewData.reviewBy} - ${reviewData.reviewComment}`,
          date: reviewData.reviewDate
        }
      };

      console.log('發送審核不通過請求:', updateData);

      // 調用API更新任務狀態
      const url = `${this.apiUrl}/api/law_check_list/law-check-info/update`;

      this.http.post(url, updateData).subscribe({
        next: (response: any) => {
          console.log('審核不通過成功:', response);

          if (response.success) {
            alert('審核不通過處理完成！任務已退回給負責部門。');

            // 更新本地任務狀態
            if (this.selectedTask) {
              this.selectedTask.status = 'in_progress';
            }

            // 重新載入任務列表
            this.loadTaskList();

          } else {
            console.error('審核不通過失敗:', response.message);
            alert('審核不通過失敗: ' + (response.message || '未知錯誤'));
          }
        },
        error: (error) => {
          console.error('審核不通過API調用失敗:', error);
          alert('審核不通過失敗: ' + (error.error?.message || error.message || '網路錯誤'));
        }
      });

    } catch (error) {
      console.error('審核不通過處理失敗:', error);
      alert('審核不通過處理失敗: ' + (error instanceof Error ? error.message : '未知錯誤'));
    }
  }

  // 計算不符合項目數量
  private calculateNonComplianceCount(): number {
    let count = 0;

    // 遍歷所有資料中的法條
    this.alldata.forEach((item: any) => {
      if (item.laws && item.laws.law_articles) {
        item.laws.law_articles.forEach((article: any) => {
          if (article.compliance_result?.result?.non_compliance === 'V') {
            count++;
          }
        });
      }
    });

    return count;
  }

  // 創建改善項目
  private createImprovementItems(reviewData: any): void {
    // TODO: 實作創建改善項目的 API 調用
    console.log('創建改善項目:', {
      taskId: reviewData.taskId,
      nonComplianceItems: this.getNonComplianceItems(),
      createdBy: reviewData.reviewBy,
      createdDate: reviewData.reviewDate
    });

    // 將來這裡會調用 API 創建改善項目
    // this.improvementService.createItems(improvementData).subscribe(...);
  }

  // 獲取不符合項目的詳細資料
  private getNonComplianceItems(): any[] {
    const nonComplianceItems: any[] = [];

    console.log("this.alldata",this.alldata);

    this.alldata.forEach((item: any) => {
      if (item.laws && item.laws.law_articles) {
        item.laws.law_articles.forEach((article: any) => {
          if (article.compliance_result?.result?.non_compliance === 'V') {
            nonComplianceItems.push({
              lawId: item.lawId,
              lawName: item.laws.law_name,
              articleId: article.article_id,
              articleNo: article.article_no,
              articleContent: article.article_content,
              complianceResult: article.compliance_result,
              comments: article.compliance_result?.comments || '',
             check_result_id:article.compliance_result?.id || ''
            });
          }
        });
      }
    });

    return nonComplianceItems;
  }

  // 處理改善項目拋轉
  private processImprovementItemsTransfer(): Promise<void> {
    return new Promise((resolve, reject) => {
      const nonComplianceItems = this.getNonComplianceItems();

      if (nonComplianceItems.length === 0) {
        console.log('沒有不符合項目需要拋轉');
        resolve();
        return;
      }

      console.log('準備拋轉不符合項目:', nonComplianceItems);

      // 準備要新增到 law_unfit_list 的資料
      const unfitItems = nonComplianceItems.map(item => ({
        id: this.generateUniqueId(),
        companyid: environment.companyid,
        mission_id: this.selectedTask?.id ,
        law_name: item.lawName,
        article_no: item.articleNo,
        article_content: item.articleContent,
        current_status: '', // 預設狀態
        risk_opportunity: [],
        solution: [],
        improvement_content: item.comments ,
        assignee: '',
        email: '',
        priority: '', // 預設優先級
        status: '',
        due_date: '',
        attachments: [],
        created_date: new Date().toISOString(),
        created_by: this.authService.getUserInfo().username,
        updated_date: new Date().toISOString(),
        updated_by: this.authService.getUserInfo().username,
        check_result_id: item.check_result_id, // 對應的 law_check_list 中的 id
      }));

      // 調用 API 批量新增到 law_unfit_list
      this.addItemsToUnfitList(unfitItems).then(() => {
        // 更新原始合規判別資料，標記為已拋轉
        return this.updateComplianceItemsAsTransferred(unfitItems);
      }).then(() => {
        console.log('改善項目拋轉完成');
        resolve();
      }).catch((error) => {
        console.error('改善項目拋轉失敗:', error);
        reject(error);
      });
    });
  }

  // 批量新增項目到 law_unfit_list
  private addItemsToUnfitList(items: any[]): Promise<void> {
    return new Promise((resolve, reject) => {
      if (items.length === 0) {
        resolve();
        return;
      }

      console.log(`準備批量新增 ${items.length} 個改善項目`);

      // 使用單筆新增API並行處理所有項目
      const addPromises = items.map((item, index) => {
        const url = `${this.apiUrl}/api/regulation/unfit/add`;

        console.log(`新增改善項目 ${index + 1}/${items.length}:`, item);

        return this.http.post(url, item).toPromise();
      });

      // 等待所有項目新增完成
      Promise.all(addPromises).then((responses: any[]) => {
        const successCount = responses.filter(response => response?.success).length;
        const failCount = responses.length - successCount;

        console.log(`批量新增完成: 成功 ${successCount} 筆, 失敗 ${failCount} 筆`);

        if (failCount === 0) {
         alert('所有改善項目新增成功');
          resolve();
        } else if (successCount > 0) {
          alert(`部分改善項目新增失敗: ${failCount} 筆失敗, ${successCount} 筆成功`);
          // 部分成功的情況，可以選擇繼續或失敗
          resolve(); // 這裡選擇繼續，可根據需求調整
        } else {
          reject(new Error('所有改善項目新增都失敗'));
        }
      }).catch((error) => {
        console.error('批量新增改善項目失敗:', error);
        reject(new Error(error.error?.message || error.message || '批量新增失敗'));
      });
    });
  }

  // 更新合規判別項目為已拋轉狀態
  private updateComplianceItemsAsTransferred(items: any[]): Promise<void> {
    return new Promise((resolve, reject) => {
      // TODO: 實作更新合規判別資料的邏輯
      // 這裡需要更新原始的 compliance_result 資料，標記為已拋轉

      const updatePromises = items.map(item => {
        // 找到對應的 article 並更新其狀態
        const updateData = {
          companyid: environment.companyid,
          id: item.id, //不符合事項的id
          check_result_id: item.check_result_id, //該項目在 law_check_list 中的 id
        };

        console.log('更新合規判別項目狀態:', updateData);

        // 調用更新 API
        const url = `${this.apiUrl}/api/law_check_list/update_unfit_id`;
        return this.http.post(url, updateData).toPromise();
      });

      Promise.all(updatePromises).then(() => {
        console.log('成功更新合規判別項目狀態');
        resolve();
      }).catch((error) => {
        console.error('更新合規判別項目狀態失敗:', error);
        reject(error);
      });
    });
  }

  // 生成唯一ID
  private generateUniqueId(): string {
    return uuidv4(); // 使用 uuidv4 生成唯一 ID
  }

  // ========== 篩選和排序功能 ==========

  // 切換篩選面板展開/收起
  toggleFilterPanel(): void {
    this.isFilterExpanded = !this.isFilterExpanded;
  }

  // 應用篩選條件
  applyFilters(): void {
    this.availableTasks = this.filterTasks(this.originalTasks);
    this.applySorting();
  }

  // 清除所有篩選條件
  clearFilters(): void {
    this.filterCriteria = {
      dateRange: {
        startDate: '',
        endDate: ''
      },
      departments: [],
      status: [],
      keyword: ''
    };
    this.selectedDepartmentFilter = '';
    this.selectedFilterStatus = '';
    this.ensureDateRange();
    this.sortCriteria = {
      field: '',
      direction: 'desc'
    };
    this.availableTasks = [...this.originalTasks];
  }
  // 在 setQuickDateRange 及其他會直接操作 dateRange 的地方也補強
  setQuickDateRange(range: string): void {
    this.ensureDateRange();
    const today = new Date();
    const startDate = new Date();
    switch (range) {
      case 'thisMonth':
        startDate.setDate(1);
        this.filterCriteria.dateRange = {
          startDate: this.formatDateForInput(startDate),
          endDate: this.formatDateForInput(today)
        };
        break;
      case 'thisQuarter':
        const quarter = Math.floor(today.getMonth() / 3);
        startDate.setMonth(quarter * 3, 1);
        this.filterCriteria.dateRange = {
          startDate: this.formatDateForInput(startDate),
          endDate: this.formatDateForInput(today)
        };
        break;
      case 'thisYear':
        startDate.setMonth(0, 1);
        this.filterCriteria.dateRange = {
          startDate: this.formatDateForInput(startDate),
          endDate: this.formatDateForInput(today)
        };
        break;
      case 'last30Days':
        startDate.setDate(today.getDate() - 30);
        this.filterCriteria.dateRange = {
          startDate: this.formatDateForInput(startDate),
          endDate: this.formatDateForInput(today)
        };
        break;
      case 'last90Days':
        startDate.setDate(today.getDate() - 90);
        this.filterCriteria.dateRange = {
          startDate: this.formatDateForInput(startDate),
          endDate: this.formatDateForInput(today)
        };
        break;
    }
    this.ensureDateRange();
    this.applyFilters();
  }

  // 篩選任務
  private filterTasks(tasks: any[]): any[] {
    return tasks.filter(task => {
      // 時間區間篩選
      if (this.filterCriteria.dateRange.startDate || this.filterCriteria.dateRange.endDate) {
        const taskStartDate = new Date(task.startDate);
        const taskEndDate = new Date(task.endDate);

        if (this.filterCriteria.dateRange.startDate) {
          const filterStartDate = new Date(this.filterCriteria.dateRange.startDate);
          if (taskStartDate < filterStartDate) {
            return false;
          }
        }

        if (this.filterCriteria.dateRange.endDate) {
          const filterEndDate = new Date(this.filterCriteria.dateRange.endDate);
          if (taskEndDate > filterEndDate) {
            return false;
          }
        }
      }

      // 建別群組篩選
      if (this.filterCriteria.departments && this.filterCriteria.departments.length > 0) {
        const taskDepartment = task.assign_to || '';
        if (!this.filterCriteria.departments.includes(taskDepartment)) {
          return false;
        }
      }

      // 狀態篩選
      if (this.filterCriteria.status && this.filterCriteria.status.length > 0) {
        const taskStatus = this.getTaskStatus(task).status;
        if (!this.filterCriteria.status.includes(taskStatus)) {
          return false;
        }
      }

      // 關鍵字搜尋
      if (this.filterCriteria.keyword) {
        const keyword = this.filterCriteria.keyword.toLowerCase();
        const title = (task.title || '').toLowerCase();
        const topic = (task.topic || '').toLowerCase();

        if (!title.includes(keyword) && !topic.includes(keyword)) {
          return false;
        }
      }

      return true;
    });
  }

  // 應用排序
  private applySorting(): void {
    if (!this.sortCriteria.field) {
      return;
    }

    this.availableTasks.sort((a, b) => {
      let valueA: any;
      let valueB: any;

      switch (this.sortCriteria.field) {
        case 'title':
          valueA = a.title || '';
          valueB = b.title || '';
          break;
        case 'topic':
          valueA = a.topic || '';
          valueB = b.topic || '';
          break;
        case 'startDate':
          valueA = new Date(a.startDate || 0);
          valueB = new Date(b.startDate || 0);
          break;
        case 'endDate':
          valueA = new Date(a.endDate || 0);
          valueB = new Date(b.endDate || 0);
          break;
        case 'completionRate':
          valueA = a.completionRate || 0;
          valueB = b.completionRate || 0;
          break;
        case 'assign_to':
          valueA = a.assign_to || '';
          valueB = b.assign_to || '';
          break;
        case 'status':
          valueA = this.getTaskStatus(a).status;
          valueB = this.getTaskStatus(b).status;
          break;
        default:
          return 0;
      }

      let comparison = 0;
      if (valueA > valueB) {
        comparison = 1;
      } else if (valueA < valueB) {
        comparison = -1;
      }

      return this.sortCriteria.direction === 'desc' ? -comparison : comparison;
    });
  }

  // 設定排序條件
  setSortCriteria(field: string): void {
    if (this.sortCriteria.field === field) {
      // 如果點擊的是相同欄位，切換排序方向
      this.sortCriteria.direction = this.sortCriteria.direction === 'asc' ? 'desc' : 'asc';
    } else {
      // 如果點擊的是不同欄位，設定新的排序欄位並預設為降序
      this.sortCriteria.field = field;
      this.sortCriteria.direction = 'desc';
    }

    this.applySorting();
  }

  // 獲取排序圖示
  getSortIcon(field: string): string {
    if (this.sortCriteria.field !== field) {
      return 'fa-sort';
    }
    return this.sortCriteria.direction === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  // 更新任務載入邏輯以保存原始資料
  updateTaskListWithFilters(tasks: any[]): void {
    this.originalTasks = [...tasks];
    this.extractAvailableDepartments();
    this.applyFilters();
  }

  // 提取可用的部門清單
  private extractAvailableDepartments(): void {
    const departments = new Set<string>();
    this.originalTasks.forEach(task => {
      if (task.assign_to) {
        departments.add(task.assign_to);
      }
    });
    this.availableDepartments = Array.from(departments).sort();
  }

  // 處理部門篩選變更
  onDepartmentFilterChange(department: string, isChecked: boolean): void {
    if (!this.filterCriteria.departments) {
      this.filterCriteria.departments = [];
    }

    if (isChecked) {
      if (!this.filterCriteria.departments.includes(department)) {
        this.filterCriteria.departments.push(department);
      }
    } else {
      const index = this.filterCriteria.departments.indexOf(department);
      if (index > -1) {
        this.filterCriteria.departments.splice(index, 1);
      }
    }
    this.applyFilters();
  }

  // 處理狀態篩選變更
  onStatusFilterChange(status: string, isChecked: boolean): void {
    if (!this.filterCriteria.status) {
      this.filterCriteria.status = [];
    }

    if (isChecked) {
      if (!this.filterCriteria.status.includes(status)) {
        this.filterCriteria.status.push(status);
      }
    } else {
      const index = this.filterCriteria.status.indexOf(status);
      if (index > -1) {
        this.filterCriteria.status.splice(index, 1);
      }
    }
    this.applyFilters();
  }

  // 處理關鍵字搜尋
  onKeywordSearch(): void {
    this.applyFilters();
  }

  // 處理日期篩選
  onDateRangeChange(): void {
    this.applyFilters();
  }

  // 檢查部門是否被選中
  isDepartmentSelected(department: string): boolean {
    return this.filterCriteria.departments?.includes(department) || false;
  }

  // 檢查狀態是否被選中
  isStatusSelected(status: string): boolean {
    return this.filterCriteria.status?.includes(status) || false;
  }

  // 格式化日期為 input 格式
  private formatDateForInput(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  // 檢查是否有啟用的篩選條件
  hasActiveFilters(): boolean {
    return !!(
      this.filterCriteria.dateRange?.startDate ||
      this.filterCriteria.dateRange?.endDate ||
      (this.filterCriteria.departments && this.filterCriteria.departments.length > 0) ||
      (this.filterCriteria.status && this.filterCriteria.status.length > 0) ||
      this.filterCriteria.keyword
    );
  }

  // 處理部門下拉選單變更
  onDepartmentDropdownChange(): void {
    this.filterCriteria.departments = this.selectedDepartmentFilter ? [this.selectedDepartmentFilter] : [];
  }

  // 處理狀態下拉選單變更
  onStatusDropdownChange(): void {
    this.filterCriteria.status = this.selectedFilterStatus ? [this.selectedFilterStatus] : [];
  }
}
